<template>
    <div class="custom-main custom-theme">
        <a-spin :spinning="loading" tip="正在提交数据....">
            <a-form class="ant-advanced-search-form">
                <a-row class="searchrow width-style-auto">
                    <a-form-item :colon="false" label="药品类型">
                        <a-select v-model="search.type">
                            <a-select-option value="">--请选择--</a-select-option>
                            <a-select-option v-for="item in init.types" :key="item.name" :value="item.name">
                                {{item.value}}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="剂型" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                      <a-select v-model="search.form">
                        <a-select-option value="">--请选择--</a-select-option>
                        <a-select-option v-for="item in init.forms" :key="item.name" :value="item.name">{{item.value}}</a-select-option>
                      </a-select>
                    </a-form-item>
                    <a-form-item :colon="false" label="药品归属">
                        <a-select v-model="search.hq">
                            <a-select-option value="">--请选择--</a-select-option>
                            <a-select-option value="1">总部</a-select-option>
                            <a-select-option value="0">自定义</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item :colon="false" label="业务状态">
                        <a-select v-model="search.status">
                            <a-select-option value="">--请选择--</a-select-option>
                            <a-select-option v-for="item in init.statuses" :key="item.name" :value="item.name">
                                {{item.value}}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item :colon="false" label="关键字">
                      <a-input v-model="search.keyword" placeholder="请输入药品名称/首拼模糊检索">
                        <img class="search-btn" slot="addonAfter" src="../../../assets/img/search.png" @click="searchAction"/>
                      </a-input>
                    </a-form-item>
                </a-row>
            </a-form>
            <a-row class="search"></a-row>
            <a-table size="middle" :columns="grid.columns" :loading="grid.loading"
                     :rowSelection="{fixed:true, selectedRowKeys: grid.selections, onChange: onSelectChange}"
                     rowKey="id" :dataSource="grid.data" :scroll="{ x: '100%' }" :pagination="grid.pagination" @change="gridChangeAction">

            </a-table>
        </a-spin>
    </div>
</template>

<script>
  export default {
    name: "StockWarn",
    data() {
      return {
        loading: false,
        init: {
          types: [],
          forms:[],
          organs:[],
          statuses: statuses
        },
        search: {
          type : '',
          form : '',
          keyword: '',
          hq:'',
          status: ''
        },
        grid: {
          loading: false,
          columns: columns,
          data: [],
          selections:[],
          pagination: this.$pagination
        }
      }
    },
    beforeCreate() {
      let data = [{
        text: "首页",
        path: ""
      },{
        text: "云药房",
        path: ""
      },{
        text: "库存预警",
        path: ""
      }];
      this.$store.commit('updateBreadcrumb', data);
    },
    mounted() {
      let self = this;
      this.loadDrugType();
      this.searchAction();
      this.getDrugForms(function (res) {
        self.init.forms = res;
      });
    },
    methods: {

      loadDrugType: function () {
        let self = this;
        this.$axios.get('/api/dmz/dict/drug/types', {}).then(function (res) {
          if (res.msg.flag == 0) {
            self.init.types = res.biz;
          }
        })
      },
      buildParams:function(){
        return {
          'entity.type' : this.search.type, 'entity.form' : this.search.form, 'entity.keyword' : this.search.keyword, 'entity.hq':('1' == this.search.hq ? true : ('0' == this.search.hq ? false : null )), 'entity.status' : this.search.status,
        };
      },
      /**
       * 搜索按钮点击动作
       */
      searchAction:function () {
        Object.assign(this.grid, {pagination: Object.assign(this.grid.pagination, {current: 1})});
        let params = Object.assign(this.buildParams(), {start: 0, length: this.grid.pagination.pageSize});
        this.loadGrid(params);
      },

      /**
       * 分页条操作
       */
      gridChangeAction: function (pagination, filters, sorter) {
        Object.assign(this.grid, {pagination: pagination});
        let params = Object.assign(this.buildParams(), {start: (pagination.current -1 ) * pagination.pageSize, length: pagination.pageSize});
        this.loadGrid(params);
      },

      /**
       *  行选择事件
       */
      onSelectChange:function(selectedRowKeys){
        this.grid.selections = selectedRowKeys;
      },

      /**
       * 查询药品
       */
      loadGrid:function(params){
        const self = this;
        self.grid.loading = true;
        self.$axios.get('/api/clinic/drug/warns', {params: params}).then(function(res){
          self.grid.loading = false;
          if(res.msg.flag == 0){
            if(null == res.biz || res.biz.empty){
              self.$message.info({content: res.msg.message, duration: 2});
              Object.assign(self.grid, {data: [], pagination: Object.assign(self.grid.pagination, {total: 0})});
            }else{
              Object.assign(self.grid, {data: res.biz.data, pagination:Object.assign(self.grid.pagination, {total: res.biz.count})});
            }
          }else{
            self.$message.error({content: res.msg.message, duration: 2});
          }
        },function(){
          self.grid.loading = false;
        });
      },

      saleAction:function(e, drugId){
        if(e){
          this.onSaleSubmit([drugId])
        }else{
          this.offSaleSubmit([drugId])
        }
      },

      batchOnSaleAction:function (e) {
        if(null == this.grid.selections || this.grid.selections.length <= 0){
          this.$message.info({content: '请选择需要上架的药品记录.', duration: 2});
          return;
        }
        this.onSaleSubmit(this.grid.selections)
      },

      onSaleSubmit:function (ids) {
        let self = this;

        self.grid.loading = true;
        this.$axios.post('/api/clinic/drug/onsale',ids).then(function (res) {
          self.grid.loading = false;
          if(res.msg.flag == 0){
            self.$message.success({content: '操作成功.', duration: 2});
            self.grid.selections = [];
            self.gridChangeAction(self.grid.pagination)
          }else {
            self.$message.error({content: res.msg.message, duration: 2});
          }
        }).catch(function (err) {
          self.grid.loading = false;
          console.info(err)
          self.$message.error({content: '操作失败', duration: 2});
        })
      },

      batchOffSaleAction:function (e) {
        if(null == this.grid.selections || this.grid.selections.length <= 0){
          this.$message.info({content: '请选择需要下架的药品记录.', duration: 2});
          return;
        }
        this.offSaleSubmit(this.grid.selections)
      },

      offSaleSubmit:function (ids) {
        let self = this;
        self.grid.loading = true;
        this.$axios.post('/api/clinic/drug/offsale',ids).then(function (res) {
          self.grid.loading = false;
          if(res.msg.flag == 0){
            self.$message.success({content: '操作成功.', duration: 2});
            self.grid.selections = [];
            self.gridChangeAction(self.grid.pagination)
          }else {
            self.$message.error({content: res.msg.message, duration: 2});
          }
        }).catch(function (err) {
          self.grid.loading = false;
          console.info(err)
          self.$message.error({content: '操作失败', duration: 2});
        })
      },

      batchCancleAction:function (e) {
        if(null == this.grid.selections || this.grid.selections.length <= 0){
          this.$message.info({content: '请选择需要作废的药品记录.', duration: 2});
          return;
        }
        this.cancelSubmit(this.grid.selections)
      },

      cancelAction:function (drugId) {
        this.cancelSubmit([drugId])
      },

      cancelSubmit:function (ids) {
        let self = this;

        self.grid.loading = true;
        this.$axios.post('/api/clinic/drug/cancel',ids).then(function (res) {
          self.grid.loading = false;
          if(res.msg.flag == 0){
            self.$message.success({content: '操作成功.', duration: 2});
            self.grid.selections = [];
            self.gridChangeAction(self.grid.pagination)
          }else {
            self.$message.error({content: res.msg.message, duration: 2});
          }
        }).catch(function (err) {
          self.grid.loading = false;
          console.info(err)
          self.$message.error({content: '操作失败', duration: 2});
        })

      }

    }
  }

  let statuses = [
    {name: 'ON_SALE', value: '已上架'},
    {name: 'OFF_SALE', value: '已下架'},
    {name: 'CANCELED', value: '已作废'},
  ];

  let columns = [
    {
      title: '药品名称',
      dataIndex: 'name',
      key: 'name',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined ? '-' : text;
      },
      width: 180
    },
    {
      title: '药品归属',
      dataIndex: 'hq',
      key: 'hq',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined ? '-' : (text ? '总部' : '自定义');
      },
      width: 120
    },
    {
      title: '药品类型',
      dataIndex: 'typeName',
      key: 'typeName',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined ? '-' : text;
      },
      width: 120
    },
    {
      title: '别名',
      dataIndex: 'alias',
      key: 'alias',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text.join(',');
      },
      width: 160
    },
    {
      title: '规格',
      dataIndex: 'spec',
      key: 'spec',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text;
      },
      width: 120
    },
    {
      title: '剂型',
      dataIndex: 'form',
      key: 'drugForm',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text;
      },
      width: 100
    },
    {
      title: '销售单位',
      dataIndex: 'salesUnit',
      key: 'salesUnit',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text;
      },
      width: 100
    },
    {
      title: '当前库存',
      dataIndex: 'stockQty',
      key: 'stockQty',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text;
      },
      width: 100
    },
    {
      title: '预警值',
      dataIndex: 'stockAlert',
      key: 'stockAlert',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text;
      },
      width: 100
    },
    {
      title: '状态',
      dataIndex: 'statusName',
      key: 'statusName',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text;
      },
      width: 120
    }

  ]
</script>

<style scoped>

</style>
